import React from "react"
import withStyles from "react-jss"
import { isMobile } from "react-device-detect"
import Map from "../components/Map"
import useWindowSize from "../hooks/useWindowSize"

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
    maxWidth: "100vw",
  },
}

const Page = ({ classes }) => {
  const screenSize = useWindowSize()
  const mobileView =
    screenSize.width < 700 || screenSize.height < 630 || isMobile ? true : false
  return (
    <section className={classes.container}>
      <Map mobileView={mobileView} screenSize={screenSize} />
    </section>
  )
}

export default withStyles(styles)(Page)
